import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ModalItem } from './modal-item';
import { AuthServiceCustom } from 'src/shared/service/auth.service';

@Injectable()
export class DynamicModalService {

    public subject = new Subject<ModalItem>();
    public subjectToModifyModaltext = new Subject<any>();
    public subjectOnClose = new Subject<any>();

    defaultHeight = '80px';
    defaultWidth = '100%';

    constructor(private authService: AuthServiceCustom) {
    }

    getModals(): Observable<any> {
        return this.subject.asObservable();
    }

    modal(componentType: any, dataT: any = { name: 'Bombasto 1', bio: 'Brave as they come' }, width = this.defaultWidth, height = this.defaultHeight, dialogArguments = null) {
        this.subjectOnClose = new Subject<any>();
        let formName = '';
        let titleOfDialog = '';
        if (typeof componentType == 'string') {
            formName = this.authService.getFormNameFromUrl(componentType);
            componentType = this.authService.getComponentTypeFromUrl(componentType);
            if (this.authService.dataOfRecentlyFetchedComponentFromUrl && this.authService.dataOfRecentlyFetchedComponentFromUrl.Title) {
                titleOfDialog = this.authService.dataOfRecentlyFetchedComponentFromUrl.Title;
            }
            else if (this.authService.dataOfRecentlyFetchedComponentFromUrl && this.authService.dataOfRecentlyFetchedComponentFromUrl.WorkflowTitle) {
                titleOfDialog = this.authService.dataOfRecentlyFetchedComponentFromUrl.WorkflowTitle;
 }
            else if (!titleOfDialog || titleOfDialog.indexOf('/') >= 0) {
                titleOfDialog = 'DialogForm';
 }
        }

        if (height == this.defaultHeight) {
            height = null;
        }
        if (width == null) {
            width = this.defaultWidth;
        }
        this.subject.next(<ModalItem>{
            component: componentType,
            data: dataT,
            titleOfDialog: titleOfDialog,
            subjectOnClose: this.subjectOnClose,
            widthOfDialog: width,
            height: height,
            dialogArguments: dialogArguments,
            formName: formName
        }
        );
        return this.subjectOnClose;
    }
}
